import { DEFAULT_LIMIT, DEFAULT_SKIP, LIMIT } from 'Src/consts/table';
import { Count } from 'Src/models/count';
import { superAdminGet } from './api';

export interface SuperAdminSchoolSubscription {
  id: string;
  schoolId: string;
  type?: string;
  provider?: string;
  status?: string;
  purchaseDate?: string;
  expireDate?: string;
  packageVolume?: number;
  note?: string;
  projectName?: string;
  from?: string;
  phoneNumber?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface SuperAdminSchoolSubscriptionsFilter {
  limit?: number;
  skip?: number;
  order?: string;
  where?: any;
}

const DEFAULT_FILTER: SuperAdminSchoolSubscriptionsFilter = {
  limit: LIMIT,
  skip: DEFAULT_SKIP,
  order: 'purchaseDate DESC'
};

function buildFilter(
  filter: SuperAdminSchoolSubscriptionsFilter = DEFAULT_FILTER
): SuperAdminSchoolSubscriptionsFilter {
  return {
    where: filter.where || {},
    skip: typeof filter.skip === 'number' ? filter.skip : DEFAULT_FILTER.skip,
    limit: typeof filter.limit === 'number' ? filter.limit : DEFAULT_FILTER.limit,
    order: filter.order || DEFAULT_FILTER.order
  };
}

export function getSuperAdminSchoolSubscriptions(
  schoolId: string,
  filter: SuperAdminSchoolSubscriptionsFilter = DEFAULT_FILTER
): Promise<SuperAdminSchoolSubscription[]> {
  return superAdminGet<SuperAdminSchoolSubscription[]>(`/schools/${schoolId}/subscriptions`, {
    params: {
      filter: buildFilter(filter)
    }
  });
}

export function getAllSuperAdminSchoolSubscriptions(
  schoolId: string,
  where?: any
): Promise<SuperAdminSchoolSubscription[]> {
  return superAdminGet<SuperAdminSchoolSubscription[]>(`/schools/${schoolId}/subscriptions`, {
    params: {
      filter: {
        where: where || {},
        skip: DEFAULT_SKIP,
        limit: DEFAULT_LIMIT,
        order: DEFAULT_FILTER.order
      }
    }
  });
}

export function getSuperAdminSchoolSubscriptionsCount(schoolId: string, where?: any): Promise<Count> {
  const config =
    typeof where !== 'undefined'
      ? {
          params: {
            filter: {
              where
            }
          }
        }
      : {};

  return superAdminGet<Count>(`/schools/${schoolId}/subscriptions/count`, config);
}

export function getSuperAdminSchoolSubscription(
  schoolId: string,
  subscriptionId: string
): Promise<SuperAdminSchoolSubscription> {
  return superAdminGet<SuperAdminSchoolSubscription>(`/schools/${schoolId}/subscriptions/${subscriptionId}`);
}
